(ns hai.entity.data
  "Web-app events shared by every entity surface."
  (:require
   [hai.ui.rf-sugar :refer [>e defevent-fx]]))

;; Clicking a linked contact/note/task chip goes to that entity's own page. Every
;; route takes the entity map itself, the way the omnibar's search results do —
;; routed by the id attr the chip's entity carries.
(defevent-fx ::open-entity [_ entity]
  {:dispatch [:routing/navigate
              (cond
                (:contact/uuid entity) [:contacts/detail entity]
                (:task/uuid entity)    [:tasks/detail entity]
                (:space/uuid entity)   [:spaces/detail entity]
                :else                  [:notes/detail entity])]})

(defn open-entity
  "The standard `:on-open-entity` handler — every web-app surface routes chips
   the same way; a surface without routing (the extension sidebar) omits the
   prop instead."
  [entity]
  (>e [::open-entity entity]))
